import * as React from 'react';
import { plural } from '@cian/utils';

const styles = require('./LinkToDetails.css');

interface ILinkToDetails {
  count: number;
  url: string;
}

export function LinkToDetails({ count, url }: ILinkToDetails) {
  return (
    <a href={`${url}#amenities`} className={styles['link-to-details']}>
      {`+ ${count} ${plural(count, ['удобство', 'удобства', 'удобств'])}`}
    </a>
  );
}
